import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { Route } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import ScrollMemory from 'react-router-scroll-memory';
import * as Sentry from '@sentry/browser';
import { Auth } from 'aws-amplify';
import { useSelector } from 'react-redux';
import RegisterLogIn from './auth/RegisterLogIn';
import Spin from 'components/common/Spin';
import Admin from './Admin';
import Lc from './Lc';
import Hc from './Hc';
import Fa from './Fa';
import Student from './Student';
import Parent from './Parent';
import { GET_USER } from '../graphql/Home';
import { setUser } from '../reducers/user';
import {
  AdminSidebar,
  LcSidebar,
  HcSidebar,
  StudentSidebar,
  ParentSidebar,
  FASidebar,
} from '../constant';
import client from '../graphql/client';
import UpdateNotification from './UpdateNotification';
import PRODUCTS from 'constant/product-types';
import DownloadFile from './pages/files/download';

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSetUser: (userinfo) => dispatch(setUser(userinfo)),
  };
};

const userMediator = (props) => {
  if (props.userType === 'student') {
    return <Student {...props} content={StudentSidebar} />;
  } else if (props.userType === 'lead_coach') {
    return <Lc {...props} content={LcSidebar} />;
  } else if (props.userType === 'admin') {
    return <Admin {...props} content={AdminSidebar} />;
  } else if (props.userType === 'head_coach') {
    return <Hc {...props} content={HcSidebar} />;
  } else if (props.userType === 'parent') {
    return <Parent {...props} content={ParentSidebar} />;
  } else if (props.userType === 'fa_coach') {
    return <Fa {...props} content={FASidebar} />;
  } else {
    return null;
  }
};

const PRODUCTS_LOOKUP = PRODUCTS.reduce((memo, i) => {
  memo[i.value] = i.label;
  return memo;
}, {});

const Home = (props) => {
  const [init, setInit] = useState(false);
  const [authUser, setAuthUser] = useState();
  const user = useSelector((state) => state.user.user);
  const userType = user.type;
  const student = useSelector((state) => {
    if (userType === 'student') {
      return state.student.profile;
    }
    return null;
  });

  useEffect(() => {
    Auth.currentAuthenticatedUser({
      bypassCache: true,
    }).then(
      (resp) => {
        client
          .query({ query: GET_USER, variables: { sub: resp.attributes.sub } })
          .then((res) => {
            const user = res.data.user[0];
            props.onSetUser(user);
            Sentry.configureScope(function(scope) {
              scope.setUser({
                email: user.user_email,
                username: user.user_cognito_username,
                id: user.user_id,
              });
            });
            setAuthUser(user);
            setInit(true);
            console.log('authenticated');
          });
      },
      (err) => {
        console.log('current authenticated user error', err);
        setInit(true);
      },
    );
  }, []);

  useEffect(() => {
    authUser &&
      student &&
      window.analytics.ready(() => {
        window.analytics.identify(authUser.user_id, {
          name: `${authUser.user_first_name} ${authUser.user_last_name}`,
          email: authUser.user_email,
          role: authUser.user_type,
          username: authUser.user_cognito_username,
          created_at: authUser.user_created_at,
          last_login_at: authUser.last_login_at,
          cc: student && student.lc_user,
          hc: student && student.hc_user,
          fc: student && student.fc_user,
          product_type: student && PRODUCTS_LOOKUP[student.product_type],
          planID:
            student &&
            student.subscriptions &&
            student.subscriptions[0]?.plan_id,
          classYear: student && student.highschool_info?.graduation_year,
        });
      });
  }, [student, authUser]);

  if (!init) {
    return <Spin spinning linear />;
  }

  if (user.id) {
    props = { ...props, userType, sub: user.sub };
    return (
      <>
        <ScrollMemory elementID="scroll-container" />
        <ApolloProvider client={client}>
          {userMediator(props)}
          <UpdateNotification />
          <Route path="/f/:id" component={DownloadFile} />
        </ApolloProvider>
      </>
    );
  } else {
    return (
      <div style={{ overflow: 'auto', height: '100%' }}>
        <RegisterLogIn />
      </div>
    );
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
